<div [@routerTransition] class="margin-top-18px">

  <div class="row">

    <div class="columnbv1">
      <div class="position-fixed-scans border-right2 padding-right-5px height-100pe">
        <div class="card height-100pe">

          <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
            <div class="row margin-top10px margin-left-20px  nav-link-hand">
              <div class="col-md-5 padding-left-0px margin-right-10px">
                <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                  Lab Orders
                </label>
              </div>

              <div class="col-md-4 col-sm-4 padding-right-0px my-profile-form margin-left-10px">
                <div class="date-form margin-top-5px form-group margin-bottom-0px">
                  <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                  <a (click)="d.toggle()" class="nav-link-hand">
                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>



              </div>
              <div class="col-md-1 " (click)="DecrementDate()">
                <a title="Previous" class="nav-link-hand">
                  <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
                </a>
              </div>
              <div class="col-md-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                <a title="Next" class="nav-link-hand">
                  <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
                </a>
              </div>

            </div>

          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">


            <div class="row margin-right-0px margin-left-0px margin-top-10">
              <!--<div class="col-md-6 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                <search-list [title]="searchTitle" [hideTitle]="1"></search-list>

              </div>-->
              <div class="col-md-6 padding-right-0px">
                <input type="search" class="form-control padding-bottom-2px " placeholder="Search....">
              </div>
              <div class="col-md-6  padding-bottom-2px border-radius-25rem">
                <div class="input-group border-radius-5px">
                  <label>
                    <select class="w3 border-radius-5px">
                      <option value=" ">  </option>
                      <option value="All "> All </option>
                      <option value="All "> Andrology </option>
                    </select>
                  </label>
                </div>
              </div>

            </div>
            <div>
              <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps scroll padding-lrt " data-ps-id="dfsfsde">
                <!--<div>

                  <div class="loader-text">
                    <div class="loader-text2">

                      <div class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <div class="margin-top-20px margin-left-5px">
                        <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                      </div>

                    </div>
                  </div>


                </div>-->
                <div>
                  <div class="row border-bottom row-for-scans2 margin-left16px nav-link-hand padding-bottom-6px">
                    <div class="col-md-2 padding-left-0px margin-top-5px">
                      <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg" onError="this.src='dummy.jpg';">



                    </div>
                    <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="margin-bottom-0px td-elipsis-scan font-size-14">GG2-L17007092</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="margin-bottom-0px td-elipsis-scan font-size-14">Surya</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="margin-bottom-0px td-elipsis-scan font-size-14">GG1I/2092</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4">
                          <label class="font-size-12px margin-bottom-0px light-gray-new">Andrology</label>
                        </div>

                      </div>

                    </div>
                    <div class="col-md-3 padding-left-0px margin-top-5px">
                      <div class="text-align-center">


                        <a data-toggle="tooltip" data-placement="bottom" title="Fully Paid">

                          <i class="fas fa-circle color-green  nav-link-hand font-size-14">
                          </i>
                        </a>

                      </div>
                      <div class="text-align-center padding-top-10 margin-bottom-0px row-height-26px"><label class="font-size-12px">5:00 AM</label></div>





                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="columnbp2">
      <div class="col-md-12 padding-left-0px">
        <div class="card">
          <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px" id="header">
            <div class="row">

              <div class="col-md-1 ">
                <img class=" margin-left-6px image-width-scans" src="dummy.jpg" onError="this.src='dummy.jpg';">

              </div>
              <div class="col-md-5 padding-left-23px">
                <div class="row row-height-17px margin-left-0px">
                  <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                    <label class="margin-bottom-0px font-weight-normal color-secondary">Surya</label>
                  </div>
                </div>


                <div class="row row-height-17px">
                  <div class="col-md-12">
                    <label class="font-size-12px margin-bottom-0px font-weight-normal">34,GG1I/2092</label>
                  </div>
                </div>
                <div class="row row-height-17px">
                  <div class="col-md-4">
                    <label class="font-size-12px margin-bottom-0px font-weight-normal">8801667136</label>
                  </div>
                </div>
              </div>
              <div class="col-md-5  padding-right-0px">
                <div class="row font-size-12px">
                  <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Order No</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px padding-left-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px ">GG2-L17007092</label>
                  </div>
                </div>
                <div class="row font-size-12px">
                  <div class="col-md-6 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Order Date</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px padding-left-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">13-09-2020</label>
                  </div>
                </div>
                <div class="row font-size-12px">
                  <div class="col-md-6 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Doctor</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px padding-left-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">Chandrakala</label>
                  </div>
                </div>
                <div class="row font-size-12px">
                  <div class="col-md-6 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Ref. Consultant</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px padding-left-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">Uma Devi</label>
                  </div>
                </div>


              </div>
            </div>

          </div>
          <div class="card-body padding-right-0px padding-top-0px padding-bottom-0px padding-left-0px">

            <div class="card">
              <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                <div class="row nav-link-hand margin-right-0px" id="edit-link">
                  <div class="col-md-5 padding-right-0px">
                    <label class="margin-bottom-0px font-size-16px font-weight-normal padding-left-10px">
                      Tests
                    </label>
                  </div>
                  <div class="col-md-6">
                    <input type="search" class="form-control padding-bottom-2px " placeholder="Search....">
                  </div>
                  <div class="col-md-1 padding-right-3px">

                    <div class="row float-left">
                      <div class="col-md-12 margin-top-3px padding-left-0px padding-right-0px text-align-right">
                        <a class="nav-link-hand education-navlink data-color-new" title="print">
                          <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                        </a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class=" padding-lrt " data-ps-id="dfsfsde">
                <div class="card-body">
                  <div id="items">
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExample">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                            <!--<div class="row">
                              <div class="col-md-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Tests
                                  </button>
                                </h5>
                              </div>

                            </div>-->


                          </div>

                          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="table-component">
                                    <div class="table-responsive overflow-x">


                                      <table class="table table-striped"
                                             cols="auto,2*,*,*,*,*,*,*">

                                        <thead class="">
                                          <tr>


                                            <th class="width-50px padding-top-4px padding-bottom-4px">
                                              #
                                            </th>
                                            <th class="padding-top-4px padding-bottom-4px">
                                              Test Name
                                            </th>

                                            <th class="text-align-center padding-top-4px padding-bottom-4px width-120px">
                                              Specimen
                                            </th>

                                            <th class="text-align-center padding-top-4px padding-bottom-4px width-140px">
                                              Result
                                            </th>
                                            <th class="text-align-center padding-top-4px padding-bottom-4px width-120px">
                                              Sign
                                            </th>

                                          </tr>
                                        </thead>

                                        <tbody class="table-body">
                                          <tr>


                                            <td class="td-padding-tb">
                                              1
                                            </td>
                                            <td class=" td-padding-tb">10 BHCG</td>

                                            <td class="text-align-center td-padding-tb">
                                              Collected <a class="nav-link-hand" (click)="SpecimenDetails()"><i class="far fa-folder-open margin-right-3px folder-color"></i></a>
                                            </td>

                                            <td class="td-padding-tb text-align-center">
                                              Results Entered <a class="nav-link-hand" (click)="ResultDetails()"><i class="far fa-folder-open margin-right-3px folder-color"></i></a>
                                            </td>
                                            <td class="td-padding-tb text-align-center" (click)="SignDetails()">
                                              Signed(1) <a class="nav-link-hand"><i class="far fa-folder-open margin-right-3px folder-color"></i></a>
                                            </td>




                                          </tr>

                                        </tbody>



                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>



                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>



                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="columnbp3">

      <div class="position-fixed-Activities3">
        <div class="card">
          <div class="card-header border-left-clinical font-size-16px border-top-1px border-right-1px border-bottom-1px border-radius-5px wh-header padding-top-3px padding-bottom-3px padding-right-0px padding-left-9px">
            Lab Information
          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px margin-left-0px">
            <div class=" margin-top-5px border-bottom-4px-document">
              <div class="row font-weight-700 margin-left-0px margin-right-0px">

                <div class="col-md-9 font-size-12px font-weight-normal padding-right-0px">
                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px color-Assign">Surya</label>

                </div>
              </div>
              <div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px">Order No</label>
                </div>:
                <div class="col-md-7 font-size-12px font-weight-normal">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">GG2-L17007092</label>
                </div>
              </div>
              <div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px">Order Date</label>
                </div>:
                <div class="col-md-7 font-size-12px font-weight-normal">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">13-09-2020</label>
                </div>
              </div>
              <div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px">Branch  </label>
                </div>:
                <div class="col-md-7 font-size-12px font-weight-normal">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">GGHO</label>
                </div>
              </div>

            </div>

            <div class="accordion" id="accordionExample">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                  <div class="row">
                    <div class="col-md-5">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          Bill Information
                        </button>
                      </h5>
                    </div>

                  </div>


                </div>

                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                    <div class="row font-weight-700">
                      <div class="col-md-4 text-align-right">
                        <label class="font-size-12px font-weight-normal margin-bottom-0px">Bill Date  </label>
                      </div>:
                      <div class="col-md-7 font-size-12px font-weight-normal">

                        <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">17-09-2020</label>
                      </div>
                    </div>

                    <div class="row font-weight-700">
                      <div class="col-md-4 text-align-right">
                        <label class="font-size-12px font-weight-normal margin-bottom-0px">Branch  </label>
                      </div>:
                      <div class="col-md-7 font-size-12px font-weight-normal">

                        <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">GGHO</label>
                      </div>
                    </div>
                    <div class="row font-weight-700">
                      <div class="col-md-4 text-align-right">
                        <label class="font-size-12px font-weight-normal margin-bottom-0px">Bill By</label>
                      </div>:
                      <div class="col-md-5 font-size-12px margin-top-3px font-weight-normal">
                        <label class="font-size-14 font-weight-normal margin-bottom-0px">Swathi</label>

                      </div>
                    </div>
                    <div class="row font-weight-700">
                      <div class="col-md-4 text-align-right">
                        <label class="font-size-12px font-weight-normal margin-bottom-0px"> Total Bill </label>
                      </div>:
                      <div class="col-md-5 font-size-12px font-weight-normal">

                        <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">15000.00</label>
                      </div>
                    </div>
                    <div class="row font-weight-700">
                      <div class="col-md-4 text-align-right">
                        <label class="font-size-12px font-weight-normal margin-bottom-0px"> Paid Bill </label>
                      </div>:
                      <div class="col-md-5 font-size-12px font-weight-normal">

                        <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">15000.00</label>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>





    </div>


  </div>
</div>

